//TODO: Split the actions into separate files

import * as apiActions from './actions'
import * as vaultActions from './vaultActions'
import * as salesActions from './salesActions'
import * as businessActions from './businessListingActions';
import * as alertTabActions from './alertTabActions';
import * as commonComponentActions from './commonComponentActions';

const ActionTypes = {
  ...apiActions,
  ...vaultActions,
  ...salesActions,
  ...businessActions,
  ...alertTabActions,
  ...commonComponentActions
}

export default ActionTypes
